import { createAdFormIntegration } from '@mint-lib/adform-integration';
import { createAmazonIntegration } from '@mint-lib/amazon-integration';
import { createAppsFlyerIntegration } from '@mint-lib/appsflyer-integration';
import { createCMIntegration } from '@mint-lib/cm-integration';
import { createGA4Integration } from '@mint-lib/ga4-integration';
import { createIntegrationRegistry } from '@mint-lib/integration-registry';
import { genericOmniIntegrations } from '@mint-lib/omni-integration';
import { createZemantaIntegration } from '@mint-lib/zemanta-integration';

// The single registration point for the whole connections integration
// registry (PDT-102320/PDT-102560).
export const integrationsCatalog = createIntegrationRegistry([
  createAppsFlyerIntegration(),
  createAdFormIntegration(),
  createGA4Integration(),
  createCMIntegration(),
  ...genericOmniIntegrations,
  createAmazonIntegration(),
  createZemantaIntegration(),
]);
